<template>
  <div style="padding:0 24px">
    <div >
      <Button type="primary" @click="addBuild" :disabled="!(projectFid && projectBuildingNum>0 && dataList.length>0 && !done)" v-p="{api:'housebuilding/saveBuildingInfo'}">添加楼栋信息</Button>
    </div>
    <build-item v-if="projectBuildingNum!==0" v-for="(item,index) in dataList"
                :formData="item"
                :itemIndex="index"
                @deletebuild="deletebuild"
                :ref="'builditem'+index"
                :propertyEnum="propertyEnum"
                :buildingStructureEnum="buildingStructureEnum"
                :directionEnum="directionEnum"
                :key="'keyA'+index"
                :disabled="!(projectFid && projectBuildingNum>0 && dataList.length>0 && !done)"
    ></build-item>
    <div>
      <save-and-cancel v-if="projectFid && projectBuildingNum>0 && dataList.length>0 && !done" @save="save" @cancel="cancel" v-p="{api:'housebuilding/saveBuildingInfo'}">
      </save-and-cancel>
    </div>
    <!--<div v-else class="cannot"><Button :size="big" >请先进行基本信息的添加</Button></div>-->
  </div>
</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import BuildItem from '../../components/BuildItem'
  import {buildCondition,saveBuildingInfo} from "../../../../../api/project";

  export default {
    name:'BuildAdd',
    props:{
      projectFid:{
        type:String,
        default:null
      },
      projectBuildingNum:{
        // type:Number,
        default:1
      }
    },
    components: {
      SaveAndCancel,
      BuildItem
    },
    data(){
      return {
        done:false,
        propertyEnum:[],
        buildingStructureEnum:[],
        directionEnum:[],
        dataList:[
          {
            "buildingArea": '',
            "buildingBusinessType": '',
            "buildingDirection": '',
            "buildingElevatornumber": '',
            "buildingFinishYear": '',
            "buildingFloorheight": '',
            "buildingFloornumber": '',
            "buildingName": "",
            "buildingOutsidearea": '',
            "buildingRentablefloor": "",
            "buildingStairnumber": '',
            "buildingStructure": '',
            "projectPropertyType": '',
            floorList: []
          },
        ]
      }
    },
    methods:{
      cancel(){
        for(var i  in this.$refs){
          this.$refs[i][0].$refs['buildItem'].resetFields()
        }
      },
      validForm(){
        var flag=true
        for(var i  in this.$refs){
          this.$refs[i][0] && this.$refs[i][0].$refs['buildItem'].validate(bool=>{
            if(bool==false){
              flag=false
            }
          })
        }
        return flag
      },

      save(){
        if(!this.validForm()){
          this.$Message.info('请检查填写内容！')
          return
        }
        this.dataList.forEach(ele=>{
          ele.buildingRentablefloor=ele.floorList.join(',')
          ele['projectFid']=this.projectFid
        })
        saveBuildingInfo(this.dataList).then(res=>{
          if(res.code==0){
            this.$Message.success('楼栋信息添加成功')
            this.$emit('builddone')
            this.done=true

          }
        })
      },
      deletebuild(index){
        if(!(this.projectFid && this.projectBuildingNum>0 && this.dataList.length>0 && !this.done)){
          return

        }
        if(!this.projectFid){
          this.$Message.info('请先进行基本信息的添加')
          return
        }
        this.$Modal.confirm({
          // title:'',
          content:'<p>确认删除本条楼栋记录？</p>',
          onOk:()=>{
            this.dataList.splice(index,1)
          }
        })
      },
      addBuild(){
        if(!this.projectFid){
          this.$Message.info('请先进行基本信息的添加')
          return
        }
        if(this.dataList.length>=this.projectBuildingNum){
          this.$Message.info('项目楼栋数为'+this.projectBuildingNum)
          return
        }
        this.dataList.push(
          {
            "buildingArea": '',
            "buildingBusinessType": '',
            "buildingDirection": '',
            "buildingElevatornumber": '',
            "buildingFinishYear": '',
            "buildingFloorheight": '',
            "buildingFloornumber": '',
            "buildingName": "",
            "buildingOutsidearea": '',
            "buildingRentablefloor": "",
            "buildingStairnumber": '',
            "buildingStructure": '',
            "projectPropertyType": '',
            floorList: []
          }
        )
      }
    },
    created(){
      buildCondition().then(res=>{
        this.directionEnum=res.data.directionEnum
        this.propertyEnum=res.data.propertyEnum
        this.buildingStructureEnum=res.data.buildingStructureEnum
      })
    },
  }
</script>

<style scoped>
  .cannot{
    text-align: center;
    margin-top: 200px;

  }
</style>
